/**
 * @description - Flag value mapper
 * @param {*} v1 - V1 - local flag.
 * @param {*} v2 - V2 stag flag.
 * @param {*} v3 - V3 vops/prod flag.
 * @returns {Object} JSON node.
 */
 export default function valueMap(v1, v2, v3) {
    return {
      local: v1,
      stag: v2,
      vops: v3,
    };
  }
  


// WEBPACK FOOTER //
// ./src/utils/flagValueMapper.js